import React, { FC } from 'react';
import { analyticsUtils } from 'utils';
import { useEffectOnce } from 'common';
import { StmBrands } from '../stm-brands';
import { AllBrands } from '../all-brands';
import { sectionStyles } from './styles';

export const Content: FC = () => {
  useEffectOnce(() => {
    const onPageLoad = () => {
      analyticsUtils.sendEvent('GA:pageview', {
        pageType: 'InfoPage', // тип страницы
        pagePath: window.location.href, // полный url страницы
      });
    };
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    return () => window.removeEventListener('load', onPageLoad);
  });

  return (
    <section className={sectionStyles}>
      <StmBrands />
      <AllBrands />
    </section>
  );
};
